
export const TEMPLATE_FILE_TYPE = {
  ASSESSMENT_SHEET: 1,                                      // アセスメントシート
  INDIVIDUAL_SUPPORT_PLAN: 2,                               // 個別支援計画
  CHANGE_CONSENT_FORM_FOR_IMPORTANT_INFORMATION_MANUAL: 3,  // 重要事項説明の変更同意書
};
